import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { WaitingForIdvResult as WaitingForIdvResultComponent } from '@imprivata/nucleus';
import LogoutStyled from '../shared/LogoutStyled';

/**
 * Displays a waiting screen while receiving the confirmation from Idv provider.
 *
 * @export
 * @class WaitingForIdvResult
 * @extends {Component}
 */
export class WaitingForIdvResult extends Component {
  /**
   * The allowed properties for the WaitingForIdvResult component
   */
  static propTypes = {
    /** Use Parkland custom UX */
    useCustomUX: PropTypes.bool,
  };
  static defaultProps = { useCustomUX: false, };

  render() {
    const { useCustomUX, } = this.props;

    const logoutStyle = useCustomUX ? 'black' : 'white';

    return (
      <div className='content-body'>
        <WaitingForIdvResultComponent
          headerTitle='Verify identity'
          logoutComponent={<LogoutStyled type={logoutStyle} />}
          useCustomUX={useCustomUX}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { useCustomUX, } = state.login;
  return { useCustomUX, };
};

export default connect(mapStateToProps)(WaitingForIdvResult);
